// import homeRoutes from '../admin/modules/home/routes'
// import DashboardRouts from '../admin/modules/Dashboard/routes'
// import SigninRouts from '../admin/modules/Authintication/routes' 
import Errors from '../admin/modules/Errors/routes'
import MassageScreens from '../admin/modules/MassageScreens/routes'
// import Settings from '../admin/modules/Settings/routes'
// import Natification from '../admin/modules/Common/routes'
// import TeacherHome from '../admin/modules/TeacherPortal/routes'
import Website from '../admin/modules/Website/routes'
export default [...Errors,...MassageScreens,...Website]